import { render, staticRenderFns } from "./g1g1.vue?vue&type=template&id=021b1366&scoped=true"
import script from "./g1g1.vue?vue&type=script&lang=js"
export * from "./g1g1.vue?vue&type=script&lang=js"
import style0 from "./g1g1.vue?vue&type=style&index=0&id=021b1366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b1366",
  null
  
)

export default component.exports